import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { QueryClientProvider } from '@tanstack/react-query';
import { CreateOrgModalProvider, Layout } from '@ui/app-components';
import { Outlet, queryClient } from '@ui/app-router';
import { AuthnProvider } from '@ui/auth';
import { env } from '@ui/environment';
import { AxiosInstance, AxiosInterceptor } from '@ui/http';
import { Toaster } from '@ui/primitives';
import { SidebarProvider } from '@ui/primitives/sidebar';
import { lazy, Suspense } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { GoogleTagManager } from './components/GoogleTagManager';
import { PostHogIdentify } from './components/PostHogIdentify';
// Devtools are excluded only in production. All other envs (local, development, preview, prerelease) get them.
// Uses PUBLIC_ENV (set by ZE_ENV at build time via rspack DefinePlugin) instead of NODE_ENV,
// because rspack build always sets NODE_ENV=production regardless of environment.
const Devtools = process.env.PUBLIC_ENV === 'production' ? ()=>null : /*#__PURE__*/ lazy(()=>import('./devtools-setup'));
// const IntercomChat = lazy(() => import('@mfe/intercom-chat'));
export function RootComponent() {
    const posthogEnabled = env.PUBLIC_USE_POSTHOG && !!env.PUBLIC_POSTHOG_KEY;
    return /*#__PURE__*/ _jsx(AxiosInstance, {
        children: /*#__PURE__*/ _jsx(QueryClientProvider, {
            client: queryClient,
            children: /*#__PURE__*/ _jsx(AuthnProvider, {
                children: /*#__PURE__*/ _jsx(AxiosInterceptor, {
                    children: /*#__PURE__*/ _jsx(HelmetProvider, {
                        children: /*#__PURE__*/ _jsxs(GoogleTagManager, {
                            children: [
                                posthogEnabled ? /*#__PURE__*/ _jsx(PostHogIdentify, {}) : null,
                                /*#__PURE__*/ _jsx(SidebarProvider, {
                                    children: /*#__PURE__*/ _jsx(CreateOrgModalProvider, {
                                        children: /*#__PURE__*/ _jsxs(Layout, {
                                            children: [
                                                /*#__PURE__*/ _jsx(Toaster, {}),
                                                /*#__PURE__*/ _jsx(Outlet, {})
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Suspense, {
                                    fallback: null,
                                    children: /*#__PURE__*/ _jsx(Devtools, {})
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
}
